


export class CostReviewProjectMgmtRequirements {
  isProjectMgmtRequirementsApplicableLessThanThreshold!: boolean;
  isProjectMgmtRequirementsApplicable!: boolean;
  frequencyOfProjectMeetings!: string;
  documentationRequirements!: string;
  timeEstimatedToManageSchedule!: number;
  estimatedPmHoursOnJobSite!: number;
}
